import React from 'react'
import { EmojiSmile } from 'react-bootstrap-icons'
import useInterests from '../../../hooks/use-interests'
import { find } from 'lodash'

const InterestName = ({
    userInterest
}) => {
    const { interests } = useInterests()

    const interest = find(interests, { id: userInterest })

    if (!interest) {
        return null
    }

    return (
        <React.Fragment>
            {interest.name}
        </React.Fragment>
    )
}

export default InterestName